module.exports = new __parcel__URL__("Planet_B_teaser_zh-cn.61ebdc3e.webp").toString();